export enum PurgeMethod {
  CreationDate = "CreationDate",
  UseDate = "UseDate",
}
